/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _circle, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _circle2, _circle3, _circle4, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _circle5, _circle6, _circle7, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _circle8, _circle9, _circle0, _path312, _path313, _path314, _path315, _circle1, _circle10, _circle11, _path316, _path317, _path318, _path319, _path320, _path321, _path322;
const ParentNode = /*#__PURE__*/React.forwardRef(function ParentNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,20c-2.41,0-4.43,1.72-4.9,4h-4.1c-2.21,0-4-1.79-4-4v-8.1c2.28-.46,4-2.48,4-4.9,0-2.76-2.24-5-5-5s-5,2.24-5,5c0,2.41,1.72,4.43,4,4.9v8.1c0,3.31,2.69,6,6,6h4.1c.46,2.28,2.48,4,4.9,4,2.76,0,5-2.24,5-5s-2.24-5-5-5ZM23,28c-1.65,0-3-1.35-3-3s1.35-3,3-3,3,1.35,3,3-1.35,3-3,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ParentNode.propTypes = iconPropTypes;
}
const PartDefinition = /*#__PURE__*/React.forwardRef(function PartDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m20.8336,16.8081c-2.4408,0-3.8336.9114-3.8336,2.7507,0,1.5986,1.0315,2.6477,2.854,2.6477,1.3408,0,2.321-.6019,2.613-1.7539h.1034c.1371.9285.7216,1.5474,1.6675,1.5474h1.2203v-1.7534h-.8938v-4.2292c0-2.0459-1.2891-3.1979-3.7133-3.1979-1.8052,0-2.8539.6879-3.5073,1.7194l1.3068,1.1689c.4296-.6189,1.0144-1.1344,2.0454-1.1344,1.1694,0,1.668.5844,1.668,1.5817v.6531h-1.5304Zm1.5304,2.51c0,.8425-.7908,1.2893-1.7705,1.2893-.8601,0-1.3586-.3608-1.3586-1.0833v-.292c0-.7048.5679-1.1002,1.7194-1.1002h1.4098v1.1862Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9.272,17.427h3.1287c2.218,0,3.5588-1.4785,3.5588-3.7133,0-2.2181-1.3408-3.7137-3.5588-3.7137h-5.3981v12h2.2694v-4.573Zm0-5.4501h2.9225c.8767,0,1.4098.4642,1.4098,1.3414v.7908c0,.8767-.5331,1.358-1.4098,1.358h-2.9225v-3.4902Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,4v24c0,1.1046.8954,2,2,2h24c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2Zm26,24H4V4h24v24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartDefinition.propTypes = iconPropTypes;
}
const PartUsage = /*#__PURE__*/React.forwardRef(function PartUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m20.8336,16.8081c-2.4408,0-3.8336.9114-3.8336,2.7507,0,1.5986,1.0315,2.6477,2.854,2.6477,1.3408,0,2.321-.6019,2.613-1.7539h.1034c.1371.9285.7216,1.5474,1.6675,1.5474h1.2203v-1.7534h-.8938v-4.2292c0-2.0459-1.2891-3.1979-3.7133-3.1979-1.8052,0-2.8539.6879-3.5073,1.7194l1.3068,1.1689c.4296-.6189,1.0144-1.1344,2.0454-1.1344,1.1694,0,1.668.5844,1.668,1.5817v.6531h-1.5304Zm1.5304,2.51c0,.8425-.7908,1.2893-1.7705,1.2893-.8601,0-1.3586-.3608-1.3586-1.0833v-.292c0-.7048.5679-1.1002,1.7194-1.1002h1.4098v1.1862Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9.272,17.427h3.1287c2.218,0,3.5588-1.4785,3.5588-3.7133,0-2.2181-1.3408-3.7137-3.5588-3.7137h-5.3981v12h2.2694v-4.573Zm0-5.4501h2.9225c.8767,0,1.4098.4642,1.4098,1.3414v.7908c0,.8767-.5331,1.358-1.4098,1.358h-2.9225v-3.4902Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartUsage.propTypes = iconPropTypes;
}
const PartitionAuto = /*#__PURE__*/React.forwardRef(function PartitionAuto({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m26,19c-2.2056,0-4,1.7944-4,4,0,.6836.1882,1.3174.4917,1.8809-1.8762,1.3726-4.146,2.1191-6.4917,2.1191-6.0654,0-11-4.9346-11-11h-2c0,7.168,5.8318,13,13,13,2.8455,0,5.5923-.936,7.8433-2.6416.6235.4019,1.3613.6416,2.1567.6416,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m16,3c-2.8455,0-5.5923.936-7.8433,2.6416-.6235-.4019-1.3613-.6416-2.1567-.6416-2.2056,0-4,1.7944-4,4s1.7944,4,4,4,4-1.7944,4-4c0-.6836-.1882-1.3174-.4917-1.8809,1.8762-1.3726,4.146-2.1191,6.4917-2.1191,6.0654,0,11,4.9346,11,11h2c0-7.168-5.8318-13-13-13ZM6,11c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartitionAuto.propTypes = iconPropTypes;
}
const PartitionCollection = /*#__PURE__*/React.forwardRef(function PartitionCollection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m26,12c-1.8584,0-3.4106,1.2798-3.8579,3h-2.7278c-.5344,0-1.0366.208-1.4143.5859l-5.4143,5.4141H2v2h10.5857c.5344,0,1.0366-.208,1.4143-.5859l5.4143-5.4141h2.7278c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m16.1717,14.5859l-3.5859-3.5859H2v-2h10.5857c.5344,0,1.0366.208,1.4143.5859l3.5859,3.5859-1.4143,1.4141Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartitionCollection.propTypes = iconPropTypes;
}
const PartitionRepartition = /*#__PURE__*/React.forwardRef(function PartitionRepartition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m26,6c-1.8584,0-3.4106,1.2798-3.8579,3h-2.7278c-.5344,0-1.0366.208-1.4143.5859l-3.5864,3.5864,1.4141,1.4141,3.5867-3.5864h2.7278c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m10.1716,17.4141l-3.5859,3.5859H2v2h4.5857c.5344,0,1.0366-.208,1.4143-.5859l3.5859-3.5859-1.4143-1.4141Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m26,18c-1.8584,0-3.4106,1.2798-3.8579,3h-2.728l-11.4141-11.4141c-.3777-.3779-.8799-.5859-1.4143-.5859H2v2h4.5859l11.4141,11.4141c.3777.3779.8799.5859,1.4143.5859h2.7278c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartitionRepartition.propTypes = iconPropTypes;
}
const PartitionSame = /*#__PURE__*/React.forwardRef(function PartitionSame({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m26,18c-1.8584,0-3.4106,1.2798-3.8579,3H2v2h20.1421c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m26,6c-1.8584,0-3.4106,1.2798-3.8579,3H2v2h20.1421c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartitionSame.propTypes = iconPropTypes;
}
const PartitionSpecific = /*#__PURE__*/React.forwardRef(function PartitionSpecific({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m26,18c-1.8584,0-3.4106,1.2798-3.8579,3h-2.728l-5.4141-5.4141c-.3777-.3779-.8799-.5859-1.4143-.5859H2v2h10.5859l5.4141,5.4141c.3777.3779.8799.5859,1.4143.5859h2.7278c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m26,6c-1.8584,0-3.4106,1.2798-3.8579,3h-2.7278c-.5344,0-1.0366.208-1.4143.5859l-3.5864,3.5864,1.4141,1.4141,3.5867-3.5864h2.7278c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartitionSpecific.propTypes = iconPropTypes;
}
const PartlyCloudy = /*#__PURE__*/React.forwardRef(function PartlyCloudy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15H31V17H27z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.086 5.794H27.329V7.794H23.086z",
    transform: "rotate(-45 25.207 6.794)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1H17V5H15z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4.672 24.208H8.915V26.208H4.672z",
    transform: "rotate(-45 6.793 25.208)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.793 4.672H7.793V8.915H5.793z",
    transform: "rotate(-45 6.793 6.794)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15H5V17H1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7939,20.3418a6.9617,6.9617,0,0,0-1.8681-3.2671A8.485,8.485,0,0,0,25,16a9,9,0,1,0-14.585,7.0332A4.9771,4.9771,0,0,0,15,30H25a4.9947,4.9947,0,0,0,1.7939-9.6582ZM9,16a6.9955,6.9955,0,0,1,13.9849-.2969A6.8883,6.8883,0,0,0,20,15a7.04,7.04,0,0,0-6.7944,5.3418A4.986,4.986,0,0,0,11.5618,21.39,6.9675,6.9675,0,0,1,9,16ZM25,28H15a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,25,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartlyCloudy.propTypes = iconPropTypes;
}
const PartlyCloudyNight = /*#__PURE__*/React.forwardRef(function PartlyCloudyNight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30,19a4.974,4.974,0,0,0-3.2061-4.6582A6.9711,6.9711,0,0,0,13.7578,12.9a13.1418,13.1418,0,0,1,.1314-8.52A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0a13.0412,13.0412,0,0,0,10.29-5.0386A4.99,4.99,0,0,0,30,19ZM14.7034,26.9976a11.0945,11.0945,0,0,1-3.201-21.584,15.1817,15.1817,0,0,0,.8443,9.3676A4.9877,4.9877,0,0,0,15,24h7.6772a11.0991,11.0991,0,0,1-7.5561,2.9976C14.9827,26.9976,14.8428,27.0024,14.7034,26.9976ZM25,22H15a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878.0005l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,25,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartlyCloudyNight.propTypes = iconPropTypes;
}
const Partnership = /*#__PURE__*/React.forwardRef(function Partnership({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8,9a4,4,0,1,1,4-4A4,4,0,0,1,8,9ZM8,3a2,2,0,1,0,2,2A2,2,0,0,0,8,3Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24,9a4,4,0,1,1,4-4A4,4,0,0,1,24,9Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,24,3Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H22a2,2,0,0,1-2-2V21h2v7h4V19h2V13a1,1,0,0,0-1-1H20.58L16,20l-4.58-8H5a1,1,0,0,0-1,1v6H6v9h4V21h2v7a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V21a2,2,0,0,1-2-2V13a3,3,0,0,1,3-3h7.58L16,16l3.42-6H27a3,3,0,0,1,3,3v6a2,2,0,0,1-2,2v7A2,2,0,0,1,26,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Partnership.propTypes = iconPropTypes;
}
const PassengerDrinks = /*#__PURE__*/React.forwardRef(function PassengerDrinks({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30,4V2H22V4a3.9906,3.9906,0,0,0,3,3.8586V11H23v2h6V11H27V7.8586A3.9906,3.9906,0,0,0,30,4Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5,9A3.5,3.5,0,1,1,14,5.5,3.5042,3.5042,0,0,1,10.5,9Zm0-5A1.5,1.5,0,1,0,12,5.5,1.5017,1.5017,0,0,0,10.5,4Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4746,31.313,19.3408,24H12.2393A4.0073,4.0073,0,0,1,8.373,21.0293l-1.6337-6.126a3.8987,3.8987,0,0,1,7.5341-2.0092L15.1016,16H21v2H13.5645l-1.2227-4.5908a1.9,1.9,0,0,0-3.6709.979l1.6338,6.1255A2.0052,2.0052,0,0,0,12.2393,22h8.42l3.6543,8.5254Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H7.7683a2.0025,2.0025,0,0,1-1.9326-1.4849L2.0337,12.2576l1.9326-.5152L7.7683,26H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PassengerDrinks.propTypes = iconPropTypes;
}
const PassengerPlus = /*#__PURE__*/React.forwardRef(function PassengerPlus({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5,9A3.5,3.5,0,1,1,14,5.5,3.5042,3.5042,0,0,1,10.5,9Zm0-5A1.5,1.5,0,1,0,12,5.5,1.5017,1.5017,0,0,0,10.5,4Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4739,31.313,19.34,24H12.2385a4.0072,4.0072,0,0,1-3.8662-2.9707l-1.6338-6.126a3.8988,3.8988,0,0,1,7.5342-2.0092L15.1008,16H21v2H13.5637l-1.2226-4.5908a1.9,1.9,0,0,0-3.6709.979l1.6338,6.1255A2.0051,2.0051,0,0,0,12.2385,22h8.42l3.6543,8.5254Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H7.7676A2.0025,2.0025,0,0,1,5.835,26.5151L2.033,12.2576l1.9326-.5152L7.7676,26H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PassengerPlus.propTypes = iconPropTypes;
}
const Password = /*#__PURE__*/React.forwardRef(function Password({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2a8.9977,8.9977,0,0,0-8.6119,11.6118L2,24v6H8L18.3881,19.6118A9,9,0,1,0,21,2Zm0,16a7.0125,7.0125,0,0,1-2.0322-.3022L17.821,17.35l-.8472.8472-3.1811,3.1812L12.4141,20,11,21.4141l1.3787,1.3786-1.5859,1.586L9.4141,23,8,24.4141l1.3787,1.3786L7.1716,28H4V24.8284l9.8023-9.8023.8472-.8474-.3473-1.1467A7,7,0,1,1,21,18Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "10",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Password.propTypes = iconPropTypes;
}
const Paste = /*#__PURE__*/React.forwardRef(function Paste({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H17.83l2.58-2.59L19,16l-5,5,5,5,1.41-1.41L17.83,22H26v8h2V22A2,2,0,0,0,26,20Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M23.71,9.29l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2h8V28H6V4h8v6a2,2,0,0,0,2,2h6v2h2V10A1,1,0,0,0,23.71,9.29ZM16,4.41,21.59,10H16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Paste.propTypes = iconPropTypes;
}
const Pause = /*#__PURE__*/React.forwardRef(function Pause({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
      d: "M6,4v8H4V4H6 M6,3H4C3.4,3,3,3.4,3,4v8c0,0.6,0.4,1,1,1h2c0.6,0,1-0.4,1-1V4C7,3.4,6.6,3,6,3z"
    })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
      d: "M12,4v8h-2V4H12 M12,3h-2C9.4,3,9,3.4,9,4v8c0,0.6,0.4,1,1,1h2c0.6,0,1-0.4,1-1V4C13,3.4,12.6,3,12,3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12,8V24H8V8h4m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M24,8V24H20V8h4m0-2H20a2,2,0,0,0-2,2V24a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pause.propTypes = iconPropTypes;
}
const PauseFilled = /*#__PURE__*/React.forwardRef(function PauseFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M12,6H10A2,2,0,0,0,8,8V24a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M22,6H20a2,2,0,0,0-2,2V24a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PauseFilled.propTypes = iconPropTypes;
}
const PauseOutline = /*#__PURE__*/React.forwardRef(function PauseOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
      d: "M7 5L6 5 6 11 7 11 7 5z"
    })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
      d: "M10 5L9 5 9 11 10 11 10 5z"
    })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
      d: "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10L12 10 12 22 14 22 14 10 14 10z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10L18 10 18 22 20 22 20 10 20 10z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PauseOutline.propTypes = iconPropTypes;
}
const PauseOutlineFilled = /*#__PURE__*/React.forwardRef(function PauseOutlineFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M7,11H6V5h1V11z M10,11H9V5h1V11z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,22H12V10h2Zm6,0H18V10h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PauseOutlineFilled.propTypes = iconPropTypes;
}
const PauseFuture = /*#__PURE__*/React.forwardRef(function PauseFuture({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11L12 11 12 22 14 22 14 11 14 11z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11L18 11 18 22 20 22 20 11 20 11z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PauseFuture.propTypes = iconPropTypes;
}
const PausePast = /*#__PURE__*/React.forwardRef(function PausePast({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11L12 11 12 22 14 22 14 11 14 11z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11L18 11 18 22 20 22 20 11 20 11z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,0,6,6.2343V2H4v8h8V8H7.0783A11.9818,11.9818,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PausePast.propTypes = iconPropTypes;
}
const PcnENode = /*#__PURE__*/React.forwardRef(function PcnENode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PcnENode.propTypes = iconPropTypes;
}
const PcnMilitary = /*#__PURE__*/React.forwardRef(function PcnMilitary({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16L14.407 19 11 19.414 13.5 21.667 13 25 16 23.125 19 25 18.5 21.667 21 19.414 17.5 19 16 16z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M12.414 17.414L16 13.834 16 13.834 19.588 17.416 21 16 16 11 11 16 12.414 17.414z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M12.414 12.414L16 8.834 16 8.834 19.588 12.416 21 11 16 6 11 11 12.414 12.414z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PcnMilitary.propTypes = iconPropTypes;
}
const PcnPNode = /*#__PURE__*/React.forwardRef(function PcnPNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V10.9985H14Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PcnPNode.propTypes = iconPropTypes;
}
const PcnZNode = /*#__PURE__*/React.forwardRef(function PcnZNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PcnZNode.propTypes = iconPropTypes;
}
const Pdf = /*#__PURE__*/React.forwardRef(function Pdf({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M8,9H2V23H4V18H8a2,2,0,0,0,2-2V11A2,2,0,0,0,8,9Zm0,7H4V11H8Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23H12V9h4a4,4,0,0,1,4,4v6A4,4,0,0,1,16,23Zm-2-2h2a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2H14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pdf.propTypes = iconPropTypes;
}
const PdfReference = /*#__PURE__*/React.forwardRef(function PdfReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16L24 16 24 10 29 10 29 8 24 8 24 4 30 4 30 2 22 2 22 16z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2H12V16h4a4,4,0,0,0,4-4V6A4,4,0,0,0,16,2Zm2,10a2,2,0,0,1-2,2H14V4h2a2,2,0,0,1,2,2Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M8,2H2V16H4V11H8a2,2,0,0,0,2-2V4A2,2,0,0,0,8,2ZM8,9H4V4H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PdfReference.propTypes = iconPropTypes;
}
const Pedestrian = /*#__PURE__*/React.forwardRef(function Pedestrian({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6772,14l-1.2456-3.1143A2.9861,2.9861,0,0,0,17.646,9H13.5542a3.0018,3.0018,0,0,0-1.5439.4277L7,12.4336V18H9V13.5664l3-1.8V23.6973L8.5383,28.8906,10.2024,30,14,24.3027V11h3.646a.9949.9949,0,0,1,.9282.6289L20.3228,16H26V14Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M17.051 18.316L19 24.162 19 30 21 30 21 23.838 18.949 17.684 17.051 18.316z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,8A3.5,3.5,0,1,1,20,4.5,3.5042,3.5042,0,0,1,16.5,8Zm0-5A1.5,1.5,0,1,0,18,4.5,1.5017,1.5017,0,0,0,16.5,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pedestrian.propTypes = iconPropTypes;
}
const PedestrianFamily = /*#__PURE__*/React.forwardRef(function PedestrianFamily({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H17a2.0021,2.0021,0,0,1-2-2V23h2v5h3V23h2V19a1.0011,1.0011,0,0,0-1-1H12.2793l-2-6H4a1.0011,1.0011,0,0,0-1,1v6H5v9H9V21h2v7a2.0021,2.0021,0,0,1-2,2H5a2.0021,2.0021,0,0,1-2-2V21a2.0021,2.0021,0,0,1-2-2V13a3.0033,3.0033,0,0,1,3-3h6.2793a1.998,1.998,0,0,1,1.8975,1.3674L13.7207,16H21a3.0033,3.0033,0,0,1,3,3v4a2.0021,2.0021,0,0,1-2,2v3A2.0021,2.0021,0,0,1,20,30Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H26V19h3V13a1.0011,1.0011,0,0,0-1-1H24V10h4a3.0033,3.0033,0,0,1,3,3v6a2.0021,2.0021,0,0,1-2,2H28Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M7,9a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,7,9ZM7,3A2,2,0,1,0,9,5,2.0021,2.0021,0,0,0,7,3Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M25,9a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,25,9Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,25,3Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5,15A3.5,3.5,0,1,1,22,11.5,3.5041,3.5041,0,0,1,18.5,15Zm0-5A1.5,1.5,0,1,0,20,11.5,1.5017,1.5017,0,0,0,18.5,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PedestrianFamily.propTypes = iconPropTypes;
}
const PedestrianChild = /*#__PURE__*/React.forwardRef(function PedestrianChild({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16H17.4683l-5-6H5a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21H10v7H6V19H4V13a1.0009,1.0009,0,0,1,1-1h6.5317l5,6H26a1.0009,1.0009,0,0,1,1,1v3H25v6H22V22H20v6a2.0023,2.0023,0,0,0,2,2h3a2.0023,2.0023,0,0,0,2-2V24a2.0023,2.0023,0,0,0,2-2V19A3.0033,3.0033,0,0,0,26,16Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,15A3.5,3.5,0,1,1,27,11.5,3.5042,3.5042,0,0,1,23.5,15Zm0-5A1.5,1.5,0,1,0,25,11.5,1.5017,1.5017,0,0,0,23.5,10Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M8,9a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,8,9ZM8,3a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,8,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PedestrianChild.propTypes = iconPropTypes;
}
const Pen = /*#__PURE__*/React.forwardRef(function Pen({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3069,6.1069,30,3.4141,28.5859,2,25.8931,4.6929,24.8,3.6a1.9328,1.9328,0,0,0-2.8,0L4,21.6V28h6.4l18-18a1.9329,1.9329,0,0,0,0-2.8ZM9.6,26H6V22.4L23.4,5,27,8.6Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M8.136 7.5H18.863999999999997V9.5H8.136z",
    transform: "rotate(-45 13.5 8.5)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pen.propTypes = iconPropTypes;
}
const PenFountain = /*#__PURE__*/React.forwardRef(function PenFountain({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707,5.293l-3-3a.9994.9994,0,0,0-1.414,0L19.5859,8H17.0947A11.0118,11.0118,0,0,0,6.7124,15.3662L2.0562,28.67a1,1,0,0,0,1.2744,1.2739l13.3037-4.6562A11.012,11.012,0,0,0,24,14.9053V12.4141L29.707,6.707A.9994.9994,0,0,0,29.707,5.293Zm-7.414,6A1,1,0,0,0,22,12v2.9053A9.01,9.01,0,0,1,15.9731,23.4l-9.1677,3.209L16,17.4141,14.5859,16,5.3914,25.1948,8.6,16.0269A9.01,9.01,0,0,1,17.0947,10H20a1,1,0,0,0,.707-.293L26,4.4141,27.5859,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PenFountain.propTypes = iconPropTypes;
}
const Pending = /*#__PURE__*/React.forwardRef(function Pending({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "16",
    r: "2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pending.propTypes = iconPropTypes;
}
const PendingFilled = /*#__PURE__*/React.forwardRef(function PendingFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,18a2,2,0,1,1,2-2A2,2,0,0,1,8,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,16,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,24,18Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M10,16a2,2,0,1,1-2-2A2,2,0,0,1,10,16Zm6-2a2,2,0,1,0,2,2A2,2,0,0,0,16,14Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,24,14Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PendingFilled.propTypes = iconPropTypes;
}
const PentagonDownOutline = /*#__PURE__*/React.forwardRef(function PentagonDownOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,27.7593l-11.8274-8.6831,4.5261-14.0762h14.6025l4.5261,14.0762-11.8274,8.6831m0,2.2407c.2078,0,.4158-.0645.5918-.1938l13-9.5444c.2599-.1907.4066-.4904.4082-.8009.0005-.1036-.0151-.2085-.0481-.3109l-4.9697-15.4561c-.1331-.4136-.5176-.6938-.9519-.6938H7.9697c-.4343,0-.8188.2803-.9519.6938l-4.9697,15.4561c-.0329.1021-.0485.2067-.0481.31.0013.3108.1481.6109.4082.8018l13,9.5444c.176.1294.384.1938.5918.1938h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PentagonDownOutline.propTypes = iconPropTypes;
}
const PentagonDownSolid = /*#__PURE__*/React.forwardRef(function PentagonDownSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,30c.2078,0,.4158-.0645.5918-.1938l13-9.5444c.2599-.1907.4066-.4904.4082-.8009.0005-.1036-.0151-.2085-.0481-.3109l-4.9697-15.4561c-.1331-.4136-.5176-.6938-.9519-.6938H7.9697c-.4343,0-.8188.2803-.9519.6938l-4.9697,15.4561c-.0329.1021-.0485.2067-.0481.31.0013.3108.1481.6109.4082.8018l13,9.5444c.176.1294.384.1938.5918.1938h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PentagonDownSolid.propTypes = iconPropTypes;
}
const PentagonLeftOutline = /*#__PURE__*/React.forwardRef(function PentagonLeftOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m4.2407,16L12.9238,4.1726l14.0762,4.5261v14.6025l-14.0762,4.5261-8.6831-11.8274m-2.2407,0c0,.2078.0645.4158.1938.5918l9.5444,13c.1907.2599.4904.4066.8009.4082.1036.0005.2085-.0151.3109-.0481l15.4561-4.9697c.4136-.1331.6938-.5176.6938-.9519V7.9697c0-.4343-.2803-.8188-.6938-.9519L12.8501,2.0481c-.1021-.0329-.2067-.0485-.31-.0481-.3108.0013-.6109.1481-.8018.4082L2.1938,15.4082c-.1294.176-.1938.384-.1938.5918h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PentagonLeftOutline.propTypes = iconPropTypes;
}
const PentagonLeftSolid = /*#__PURE__*/React.forwardRef(function PentagonLeftSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,16c0,.2078.0645.4158.1938.5918l9.5444,13c.1907.2599.4904.4066.8009.4082.1036.0005.2085-.0151.3109-.0481l15.4561-4.9697c.4136-.1331.6938-.5176.6938-.9519V7.9697c0-.4343-.2803-.8188-.6938-.9519L12.8501,2.0481c-.1021-.0329-.2067-.0485-.31-.0481-.3108.0013-.6109.1481-.8018.4082L2.1938,15.4082c-.1294.176-.1938.384-.1938.5918h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PentagonLeftSolid.propTypes = iconPropTypes;
}
const PentagonOutline = /*#__PURE__*/React.forwardRef(function PentagonOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,4.2407l11.8274,8.6831-4.5261,14.0762h-14.6025l-4.5261-14.0762,11.8274-8.6831m0-2.2407c-.2078,0-.4158.0645-.5918.1938L2.4082,11.7383c-.2599.1907-.4066.4904-.4082.8009-.0005.1036.0151.2085.0481.3109l4.9697,15.4561c.1331.4136.5176.6938.9519.6938h16.0605c.4343,0,.8188-.2803.9519-.6938l4.9697-15.4561c.0329-.1021.0485-.2067.0481-.31-.0013-.3108-.1481-.6109-.4082-.8018L16.5918,2.1938c-.176-.1294-.384-.1938-.5918-.1938h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PentagonOutline.propTypes = iconPropTypes;
}
const PentagonRightOutline = /*#__PURE__*/React.forwardRef(function PentagonRightOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27.7593,16l-8.6831,11.8274-14.0762-4.5261v-14.6025l14.0762-4.5261,8.6831,11.8274m2.2407,0c0-.2078-.0645-.4158-.1938-.5918L20.2617,2.4082c-.1907-.2599-.4904-.4066-.8009-.4082-.1036-.0005-.2085.0151-.3109.0481L3.6938,7.0178c-.4136.1331-.6938.5176-.6938.9519v16.0605c0,.4343.2803.8188.6938.9519l15.4561,4.9697c.1021.0329.2067.0485.31.0481.3108-.0013.6109-.1481.8018-.4082l9.5444-13c.1294-.176.1938-.384.1938-.5918h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PentagonRightOutline.propTypes = iconPropTypes;
}
const PentagonRightSolid = /*#__PURE__*/React.forwardRef(function PentagonRightSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30,16c0-.2078-.0645-.4158-.1938-.5918L20.2617,2.4082c-.1907-.2599-.4904-.4066-.8009-.4082-.1036-.0005-.2085.0151-.3109.0481L3.6938,7.0178c-.4136.1331-.6938.5176-.6938.9519v16.0605c0,.4343.2803.8188.6938.9519l15.4561,4.9697c.1021.0329.2067.0485.31.0481.3108-.0013.6109-.1481.8018-.4082l9.5444-13c.1294-.176.1938-.384.1938-.5918h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PentagonRightSolid.propTypes = iconPropTypes;
}
const PentagonSolid = /*#__PURE__*/React.forwardRef(function PentagonSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,2c-.2078,0-.4158.0645-.5918.1938L2.4082,11.7383c-.2599.1907-.4066.4904-.4082.8009-.0005.1036.0151.2085.0481.3109l4.9697,15.4561c.1331.4136.5176.6938.9519.6938h16.0605c.4343,0,.8188-.2803.9519-.6938l4.9697-15.4561c.0329-.1021.0485-.2067.0481-.31-.0013-.3108-.1481-.6109-.4082-.8018L16.5918,2.1938c-.176-.1294-.384-.1938-.5918-.1938h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PentagonSolid.propTypes = iconPropTypes;
}
const Percentage = /*#__PURE__*/React.forwardRef(function Percentage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14ZM9,6a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,9,6Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0.029 15H31.97V17H0.029z",
    transform: "rotate(-45 16 16)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,23,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Percentage.propTypes = iconPropTypes;
}
const PercentageFilled = /*#__PURE__*/React.forwardRef(function PercentageFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0.029 15H31.97V17H0.029z",
    transform: "rotate(-45 16 16)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PercentageFilled.propTypes = iconPropTypes;
}
const PerformAction = /*#__PURE__*/React.forwardRef(function PerformAction({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2h-10C6,2,2,6,2,11v10c0,5,4,9,9,9h10c5,0,9-4,9-9v-10c0-5-4-9-9-9ZM28,21c0,3.9-3.1,7-7,7h-10c-3.9,0-7-3.1-7-7v-10c0-3.9,3.1-7,7-7h10c3.9,0,7,3.1,7,7v10ZM24,11h-6c-1.1,0-2,.9-2,2v6c0,1.1.9,2,2,2h6c1.1,0,2-.9,2-2v-6c0-1.1-.9-2-2-2ZM18,19v-6h6v6h-6ZM11,11l5,5-5,5-1.5-1.4,2.7-2.6h-6.2v-2h6.2l-2.7-2.6,1.5-1.4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PerformAction.propTypes = iconPropTypes;
}
const Person = /*#__PURE__*/React.forwardRef(function Person({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30H14a2,2,0,0,1-2-2V21a2,2,0,0,1-2-2V13a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v6a2,2,0,0,1-2,2v7A2,2,0,0,1,18,30ZM13,12a.94.94,0,0,0-1,1v6h2v9h4V19h2V13a.94.94,0,0,0-1-1Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9a4,4,0,1,1,4-4h0A4,4,0,0,1,16,9Zm0-6a2,2,0,1,0,2,2h0a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Person.propTypes = iconPropTypes;
}
const PersonFavorite = /*#__PURE__*/React.forwardRef(function PersonFavorite({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M10,31H6a2.0059,2.0059,0,0,1-2-2V22a2.0059,2.0059,0,0,1-2-2V14a2.9465,2.9465,0,0,1,3-3h6a2.9465,2.9465,0,0,1,3,3v6a2.0059,2.0059,0,0,1-2,2v7A2.0059,2.0059,0,0,1,10,31ZM5,13a.9448.9448,0,0,0-1,1v6H6v9h4V20h2V14a.9448.9448,0,0,0-1-1Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,8,10ZM8,4a2,2,0,1,0,2,2A2.002,2.002,0,0,0,8,4Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7663,4.2558A4.2121,4.2121,0,0,0,23,4.0321a4.2121,4.2121,0,0,0-5.7663.2237,4.319,4.319,0,0,0,0,6.0447L22.998,16.14,23,16.1376l.002.0019,5.7643-5.839A4.319,4.319,0,0,0,28.7663,4.2558ZM27.342,8.8948l-4.34,4.3973L23,13.29l-.002.002-4.34-4.3973a2.3085,2.3085,0,0,1,0-3.2338,2.2639,2.2639,0,0,1,3.1561,0l1.181,1.2074L23,6.8634l.0049.005,1.181-1.2074a2.2639,2.2639,0,0,1,3.1561,0A2.3085,2.3085,0,0,1,27.342,8.8948Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PersonFavorite.propTypes = iconPropTypes;
}
const Pest = /*#__PURE__*/React.forwardRef(function Pest({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.5",
    cy: "9.5",
    r: "1.5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "13",
    r: "1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "21",
    r: "1"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14a8.9844,8.9844,0,0,0-7,3.3555V13a10.9054,10.9054,0,0,0-1.0093-4.5845l-.3569-.7768L15.811,7.87A2.9549,2.9549,0,0,1,15,8a3.0033,3.0033,0,0,1-3-3,2.9574,2.9574,0,0,1,.1294-.8105l.2324-.8233-.7773-.3569A10.9115,10.9115,0,0,0,7,2H2V9a10.8954,10.8954,0,0,0,2.2339,6.627l.3887.4277.54-.0381a5.5286,5.5286,0,0,1,5.3628,3.2559l.2207.497.5376.0845A11.0219,11.0219,0,0,0,13,20h3V30h2V26h3a9.01,9.01,0,0,0,9-9V14ZM12.1016,17.9468A7.51,7.51,0,0,0,5.5283,14,8.8945,8.8945,0,0,1,4,9V4H7a8.8624,8.8624,0,0,1,3.0259.53A4.2457,4.2457,0,0,0,10,5a4.9658,4.9658,0,0,0,5.47,4.9736A8.8793,8.8793,0,0,1,16,13v5H13A8.1153,8.1153,0,0,1,12.1016,17.9468ZM28,17a7.0078,7.0078,0,0,1-7,7H18V23a7.01,7.01,0,0,1,5.0212-6.7109A1.4971,1.4971,0,1,0,26,16.5a1.485,1.485,0,0,0-.0918-.5H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pest.propTypes = iconPropTypes;
}
const WatsonHealthPetImageB = /*#__PURE__*/React.forwardRef(function WatsonHealthPetImageB({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21H21V24H19z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M19 0H21V3H19z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11H11V13H8z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M29 11H32V13H29z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M11.59 3.07H13.57V6.07H11.59z",
    transform: "rotate(-45 12.586 4.577)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M26.44 17.92H28.42V20.92H26.44z",
    transform: "rotate(-45 27.43 19.408)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M11.09 18.42H14.09V20.400000000000002H11.09z",
    transform: "rotate(-45 12.592 19.414)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M25.93 3.58H28.93V5.5600000000000005H25.93z",
    transform: "rotate(-45 27.423 4.57)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M20,5a7,7,0,1,0,7,7A7,7,0,0,0,20,5Zm0,12A5,5,0,0,1,20,7Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M5,18H0V32H5a3,3,0,0,0,3-3V27a3,3,0,0,0-.78-2A3,3,0,0,0,8,23V21A3,3,0,0,0,5,18ZM2,20H5a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H2Zm4,9a1,1,0,0,1-1,1H2V26H5a1,1,0,0,1,1,1Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L9 2 9 0 0 0 0 9 2 9 2 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthPetImageB.propTypes = iconPropTypes;
}
const WatsonHealthPetImageO = /*#__PURE__*/React.forwardRef(function WatsonHealthPetImageO({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M11 29H13V32H11z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8H13V11H11z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19H3V21H0z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19H24V21H21z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59 11.09H5.57V14.09H3.59z",
    transform: "rotate(-45 4.585 12.59)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M18.44 25.93H20.42V28.93H18.44z",
    transform: "rotate(-45 19.429 27.422)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09 26.44H6.09V28.42H3.09z",
    transform: "rotate(-45 4.591 27.428)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M17.93 11.59H20.93V13.57H17.93z",
    transform: "rotate(-45 19.423 12.585)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M12,13a7,7,0,1,0,7,7A7,7,0,0,0,12,13Zm0,12a5,5,0,0,1,0-10Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L9 2 9 0 0 0 0 9 2 9 2 2z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M30,0H26a2,2,0,0,0-2,2V12a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V2A2,2,0,0,0,30,0ZM26,12V2h4V12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthPetImageO.propTypes = iconPropTypes;
}
const Phone = /*#__PURE__*/React.forwardRef(function Phone({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.76,3h5.51a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.37,9.37,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5A1,1,0,0,0,5,6v.08C5.46,12,8.41,26,25.94,27A1,1,0,0,0,27,26.06V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Phone.propTypes = iconPropTypes;
}
const PhoneApplication = /*#__PURE__*/React.forwardRef(function PhoneApplication({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H30V6H26z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8H30V12H26z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2H24V6H20z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8H24V12H20z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30h-.17C5.18,28.87,2.39,12.29,2,7.23A3,3,0,0,1,4.7611,4.0088Q4.88,4,5,4h5.27a2,2,0,0,1,1.86,1.26L13.65,9a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,23,18.35l3.77,1.51A2,2,0,0,1,28,21.72V27A3,3,0,0,1,25,30ZM5,6a1,1,0,0,0-1.0032.9968c0,.0278.001.0555.0032.0832C4.46,13,7.41,27,24.94,28a1,1,0,0,0,1.0581-.9382Q26,27.0309,26,27V21.72l-3.77-1.51-2.87,2.85L18.88,23C10.18,21.91,9,13.21,9,13.12l-.06-.48,2.84-2.87L10.28,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneApplication.propTypes = iconPropTypes;
}
const PhoneBlock = /*#__PURE__*/React.forwardRef(function PhoneBlock({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneBlock.propTypes = iconPropTypes;
}
const PhoneBlockFilled = /*#__PURE__*/React.forwardRef(function PhoneBlockFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneBlockFilled.propTypes = iconPropTypes;
}
const PhoneFilled = /*#__PURE__*/React.forwardRef(function PhoneFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M20.33,21.48l2.24-2.24a2.19,2.19,0,0,1,2.34-.48l2.73,1.09a2.18,2.18,0,0,1,1.36,2v5A2.17,2.17,0,0,1,26.72,29C7.59,27.81,3.73,11.61,3,5.41A2.17,2.17,0,0,1,5.17,3H10a2.16,2.16,0,0,1,2,1.36l1.09,2.73a2.16,2.16,0,0,1-.47,2.34l-2.24,2.24S11.67,20.4,20.33,21.48Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneFilled.propTypes = iconPropTypes;
}
const PhoneIncoming = /*#__PURE__*/React.forwardRef(function PhoneIncoming({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneIncoming.propTypes = iconPropTypes;
}
const PhoneIncomingFilled = /*#__PURE__*/React.forwardRef(function PhoneIncomingFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneIncomingFilled.propTypes = iconPropTypes;
}
const PhoneIp = /*#__PURE__*/React.forwardRef(function PhoneIp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14H18V16H16z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14H22V16H20z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14H26V16H24z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18H18V20H16z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H22V20H20z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18H26V20H24z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H18V24H16z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22H22V24H20z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22H26V24H24z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10H26V12H16z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H14V5a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,5V6H4A2.0025,2.0025,0,0,0,2,8V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V8A2.0025,2.0025,0,0,0,28,6ZM8,5h4V22H8ZM28,26H4V8H6V22a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V8H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneIp.propTypes = iconPropTypes;
}
const PhoneOff = /*#__PURE__*/React.forwardRef(function PhoneOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19,18.56A25.66,25.66,0,0,1,5,6.08V6A1,1,0,0,1,6,5h5.28l1.5,3.77L9.94,11.64l.06.48a13,13,0,0,0,1.46,4.17l1.46-1.46a9.34,9.34,0,0,1-.84-2.52l2.13-2.15A2,2,0,0,0,14.65,8L13.13,4.26A2,2,0,0,0,11.27,3H5.76A3,3,0,0,0,3,6.23,28,28,0,0,0,7.79,20Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M27.77,18.86,24,17.35a2,2,0,0,0-2.17.41l-2.17,2.15A9.17,9.17,0,0,1,15.45,18L30,3.41,28.59,2,2,28.59,3.41,30l7-7c3.38,3.18,8.28,5.62,15.39,6H26a3,3,0,0,0,3-3V20.72A2,2,0,0,0,27.77,18.86ZM27,26v.06a1,1,0,0,1-1.06.94c-6.51-.37-11-2.54-14.11-5.42L14,19.44A10.77,10.77,0,0,0,19.88,22l.48.06,2.87-2.85L27,20.72Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneOff.propTypes = iconPropTypes;
}
const PhoneOffFilled = /*#__PURE__*/React.forwardRef(function PhoneOffFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M26.74,19.56l-2.52-1a2,2,0,0,0-2.15.44L20,21.06a9.93,9.93,0,0,1-5.35-2.29L30,3.41,28.59,2,2,28.59,3.41,30l7.93-7.92c3.24,3.12,7.89,5.5,14.55,5.92A2,2,0,0,0,28,26V21.41A2,2,0,0,0,26.74,19.56Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15,18.19l3.52-3.52A11.68,11.68,0,0,1,10.85,12l2.07-2.07a2,2,0,0,0,.44-2.15l-1-2.52A2,2,0,0,0,10.5,4H6A2,2,0,0,0,4,6.22,29,29,0,0,0,8.15,18.19Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneOffFilled.propTypes = iconPropTypes;
}
const PhoneOutgoing = /*#__PURE__*/React.forwardRef(function PhoneOutgoing({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-0.2C6.2,27.9,3.4,11.3,3,6.2C2.9,4.6,4.1,3.1,5.8,3C5.8,3,5.9,3,6,3h5.3c0.8,0,1.6,0.5,1.9,1.3L14.6,8 c0.3,0.7,0.1,1.6-0.4,2.2l-2.1,2.1c0.7,3.9,3.7,6.9,7.6,7.6l2.2-2.1c0.6-0.6,1.4-0.7,2.2-0.4l3.8,1.5c0.7,0.3,1.2,1,1.2,1.9V26 C29,27.7,27.7,29,26,29z M6,5C5.4,5,5,5.4,5,6c0,0,0,0.1,0,0.1C5.5,12,8.4,26,25.9,27c0.6,0,1-0.4,1.1-0.9c0,0,0,0,0-0.1v-5.3 l-3.8-1.5l-2.9,2.9L19.9,22c-8.7-1.1-9.9-9.8-9.9-9.9l-0.1-0.5l2.8-2.9L11.3,5H6z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4L20 6 24.6 6 18 12.6 19.4 14 26 7.4 26 12 28 12 28 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneOutgoing.propTypes = iconPropTypes;
}
const PhoneOutgoingFilled = /*#__PURE__*/React.forwardRef(function PhoneOutgoingFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4L20 6 24.586 6 18 12.586 19.414 14 26 7.414 26 12 28 12 28 4 20 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneOutgoingFilled.propTypes = iconPropTypes;
}
const PhoneSettings = /*#__PURE__*/React.forwardRef(function PhoneSettings({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30h-.17C5.18,28.87,2.39,12.29,2,7.23A3,3,0,0,1,4.7611,4.0088Q4.88,4,5,4h5.27a2,2,0,0,1,1.86,1.26L13.65,9a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,23,18.35l3.77,1.51A2,2,0,0,1,28,21.72V27A3,3,0,0,1,25,30ZM5,6a1,1,0,0,0-1.0032.9968c0,.0278.001.0555.0032.0832C4.46,13,7.41,27,24.94,28a1,1,0,0,0,1.0581-.9382Q26,27.0309,26,27V21.72l-3.77-1.51-2.87,2.85L18.88,23C10.18,21.91,9,13.21,9,13.12l-.06-.48,2.84-2.87L10.28,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneSettings.propTypes = iconPropTypes;
}
const PhoneVoice = /*#__PURE__*/React.forwardRef(function PhoneVoice({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M28,13H26a7.0078,7.0078,0,0,0-7-7V4A9.01,9.01,0,0,1,28,13Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneVoice.propTypes = iconPropTypes;
}
const PhoneVoiceFilled = /*#__PURE__*/React.forwardRef(function PhoneVoiceFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M28,13H26a7.0078,7.0078,0,0,0-7-7V4A9.01,9.01,0,0,1,28,13Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneVoiceFilled.propTypes = iconPropTypes;
}
const PhraseSentiment = /*#__PURE__*/React.forwardRef(function PhraseSentiment({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M18.303,10a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,19l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,10Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhraseSentiment.propTypes = iconPropTypes;
}
const PicnicArea = /*#__PURE__*/React.forwardRef(function PicnicArea({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M24,12a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,12Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,24,6Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22H21.8472L21.18,18H24V16H8v2h2.82l-.6668,4H6v2H9.82l-.6668,4H11.18l.6668-4h8.3056l.6668,4h2.0276L22.18,24H26ZM12.18,22l.6665-4h6.3062l.6665,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PicnicArea.propTypes = iconPropTypes;
}
const PiggyBank = /*#__PURE__*/React.forwardRef(function PiggyBank({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,14H20V12H18V11H16v1.0508A2.5,2.5,0,0,0,16.5,17h1a.5.5,0,0,1,0,1H14v2h2v1h2V19.9492A2.5,2.5,0,0,0,17.5,15h-1a.5.5,0,0,1,0-1Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M29,13H26.98A5.7789,5.7789,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0926,5.0926,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.013,7.013,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PiggyBank.propTypes = iconPropTypes;
}
const PiggyBankSlot = /*#__PURE__*/React.forwardRef(function PiggyBankSlot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11H20V13H13z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M29,13H26.98A5.7791,5.7791,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0928,5.0928,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.0129,7.0129,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PiggyBankSlot.propTypes = iconPropTypes;
}
const Pills = /*#__PURE__*/React.forwardRef(function Pills({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.999,6.999,0,0,0,12.2855,4.5878A7.9969,7.9969,0,1,0,22,14Zm0,2a6.0046,6.0046,0,0,1,5.91,5H16.09A6.0046,6.0046,0,0,1,22,16ZM6,9A5,5,0,0,1,16,9v6H6Zm5,19a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9566,7.9566,0,0,0-.7242,8.9315A4.9885,4.9885,0,0,1,11,28Zm11,0a6.0046,6.0046,0,0,1-5.91-5H27.91A6.0046,6.0046,0,0,1,22,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pills.propTypes = iconPropTypes;
}
const PillsAdd = /*#__PURE__*/React.forwardRef(function PillsAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21L23 21 23 19 21 19 21 21 19 21 19 23 21 23 21 25 23 25 23 23 25 23 25 21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PillsAdd.propTypes = iconPropTypes;
}
const PillsSubtract = /*#__PURE__*/React.forwardRef(function PillsSubtract({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21H25V23H19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PillsSubtract.propTypes = iconPropTypes;
}
const Pin = /*#__PURE__*/React.forwardRef(function Pin({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M28.59,13.31,30,11.9,20,2,18.69,3.42,19.87,4.6,8.38,14.32,6.66,12.61,5.25,14l5.66,5.68L2,28.58,3.41,30l8.91-8.91L18,26.75l1.39-1.42-1.71-1.71L27.4,12.13ZM16.26,22.2,9.8,15.74,21.29,6,26,10.71Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pin.propTypes = iconPropTypes;
}
const PinFilled = /*#__PURE__*/React.forwardRef(function PinFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5858,13.3137,30,11.9,20,2,18.6858,3.415l1.1858,1.1857L8.38,14.3225,6.6641,12.6067,5.25,14l5.6572,5.6773L2,28.5831,3.41,30l8.9111-8.9087L18,26.7482l1.3929-1.414L17.6765,23.618l9.724-11.4895Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PinFilled.propTypes = iconPropTypes;
}
const Pipelines = /*#__PURE__*/React.forwardRef(function Pipelines({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M22,12h6c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2h-6c-1.1028,0-2,.8975-2,2v2h-9c-2.7571,0-5,2.2432-5,5h-2c-1.1028,0-2,.8975-2,2v6c0,1.1025.8972,2,2,2h2c0,2.7568,2.2429,5,5,5h9v2c0,1.1025.8972,2,2,2h6c1.1028,0,2-.8975,2-2v-6c0-1.1025-.8972-2-2-2h-6c-1.1028,0-2,.8975-2,2v2h-9c-1.6543,0-3-1.3457-3-3h2c1.1028,0,2-.8975,2-2v-6c0-1.1025-.8972-2-2-2h-2c0-1.6543,1.3457-3,3-3h9v2c0,1.1025.8972,2,2,2ZM22,22h6v6h-6l-.0012-6h.0012ZM10,13v6h-6l-.0012-6h6.0012ZM22,4h6v6h-6l-.0012-6h.0012Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pipelines.propTypes = iconPropTypes;
}
const Plan = /*#__PURE__*/React.forwardRef(function Plan({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M31,8c0-0.4-0.2-0.7-0.5-0.9l-7-4C23.3,3,23.2,3,23,3s-0.3,0-0.5,0.1L16,6.8L9.5,3.1C9.3,3,9.2,3,9,3S8.7,3,8.5,3.1l-7,4 C1.2,7.3,1,7.6,1,8v20c0,0.6,0.4,1,1,1c0.2,0,0.3-0.1,0.5-0.1l0,0L9,25.2l6.5,3.7C15.7,29,15.8,29,16,29s0.3,0,0.5-0.1l6.5-3.7 l6.5,3.7l0,0c0.1,0.1,0.3,0.1,0.5,0.1c0.6,0,1-0.4,1-1V8z M3,8.6l5-2.9v17.7l-5,2.9V8.6z M15,26.3l-5-2.9V5.7l5,2.9V26.3z M22,23.4 l-5,2.9V8.6l5-2.9V23.4z M24,23.4V5.7l5,2.9l0,17.7L24,23.4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Plan.propTypes = iconPropTypes;
}
const Plane = /*#__PURE__*/React.forwardRef(function Plane({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M29.37,14.75,20,10V6a4,4,0,0,0-8,0v4L2.63,14.75a1,1,0,0,0-.63.93v5a1,1,0,0,0,1,1,1,1,0,0,0,.29-.05L12,18v5L8.55,24.72a1,1,0,0,0-.55.9V29a1,1,0,0,0,1,1,.9.9,0,0,0,.28,0L16,28l6.72,2A.9.9,0,0,0,23,30a1,1,0,0,0,1-1V25.62a1,1,0,0,0-.55-.9L20,23V18l8.71,3.61a1,1,0,0,0,.29.05,1,1,0,0,0,1-1v-5A1,1,0,0,0,29.37,14.75ZM28,19.15,18,15v9.24l4,2v1.43l-6-1.75-6,1.75V26.24l4-2V15L4,19.15V16.3l10-5.07V6a2,2,0,0,1,4,0v5.23L28,16.3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Plane.propTypes = iconPropTypes;
}
const PlanePrivate = /*#__PURE__*/React.forwardRef(function PlanePrivate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5845,14.585l-3.12-1.8721A4.9951,4.9951,0,0,0,22.8921,12H7.7808L7.16,9.5151A1.9975,1.9975,0,0,0,5.2192,8H4a2.0023,2.0023,0,0,0-2,2v7a3.0033,3.0033,0,0,0,3,3h7v6a2.0023,2.0023,0,0,0,2,2h1.3071A2.0086,2.0086,0,0,0,17.18,26.7021L19.6929,20h7.3916a2.9152,2.9152,0,0,0,1.5-5.415ZM27.0845,18H18.3071l-3,8H14V18H5a1.0009,1.0009,0,0,1-1-1V10H5.2192l1,4H10v2h2V14h3v2h2V14h3v2h2V14h.8921a2.9977,2.9977,0,0,1,1.5434.4277l3.12,1.8721a.9154.9154,0,0,1-.4712,1.7Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4h1.3228l2.4,6h2.1545L17.18,3.2573A1.9906,1.9906,0,0,0,15.3228,2H14a2.0023,2.0023,0,0,0-2,2v6h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PlanePrivate.propTypes = iconPropTypes;
}
const PlaneSea = /*#__PURE__*/React.forwardRef(function PlaneSea({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H28a4.9316,4.9316,0,0,1-4-1.9873,5.0192,5.0192,0,0,1-8,0,5.0192,5.0192,0,0,1-8,0A4.9316,4.9316,0,0,1,4,30H2V28H4a3.44,3.44,0,0,0,3.0532-2.3215A.9712.9712,0,0,1,8,25a1.0069,1.0069,0,0,1,.9487.6838A3.4381,3.4381,0,0,0,12,28a3.44,3.44,0,0,0,3.0532-2.3215A.99.99,0,0,1,16,25a1.0069,1.0069,0,0,1,.9487.6838A3.4381,3.4381,0,0,0,20,28a3.44,3.44,0,0,0,3.0532-2.3215,1,1,0,0,1,1.8955.0053A3.4381,3.4381,0,0,0,28,28h2Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6v4H25.5L23.4,7.2A3.0129,3.0129,0,0,0,21,6H15a3.0033,3.0033,0,0,0-3,3v1H8.6182L7.8945,8.5527l-1-2A1,1,0,0,0,6,6H3A1,1,0,0,0,2,7v6a3.0033,3.0033,0,0,0,3,3h6.82l-.6666,4H7a1,1,0,0,0,0,2H27a1,1,0,0,0,0-2H22.847L22.18,16h.1629a4.9662,4.9662,0,0,0,3.5351-1.4648L28,12.4141V16h2V6ZM14,9a1.0009,1.0009,0,0,1,1-1h6a1.0045,1.0045,0,0,1,.8.4L23,10H14Zm6.82,11H13.18l.6666-4h6.306Zm1.5237-6H5a1.0009,1.0009,0,0,1-1-1V8H5.3818l.7237,1.4473L7.3818,12h18.204l-1.1214,1.1211A2.9789,2.9789,0,0,1,22.3433,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PlaneSea.propTypes = iconPropTypes;
}
const Platforms = /*#__PURE__*/React.forwardRef(function Platforms({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "m28,28H4c-1.1028,0-2-.8972-2-2v-6h2v6h24v-6h2v6c0,1.1028-.8972,2-2,2Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "m17,17v4c0,.5522.4477,1,1,1h4c.5523,0,1-.4478,1-1v-4c0-.5523-.4477-1-1-1h-4c-.5523,0-1,.4477-1,1Zm2,1h2v2h-2v-2Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "m9,17v4c0,.5522.4477,1,1,1h4c.5523,0,1-.4478,1-1v-4c0-.5523-.4477-1-1-1h-4c-.5523,0-1,.4477-1,1Zm2,1h2v2h-2v-2Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "m17,9v4c0,.5522.4477,1,1,1h4c.5523,0,1-.4478,1-1v-4c0-.5523-.4477-1-1-1h-4c-.5523,0-1,.4477-1,1Zm2,1h2v2h-2v-2Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "m5,5v8c0,.5522.4477,1,1,1h8c.5523,0,1-.4478,1-1V5c0-.5523-.4477-1-1-1H6c-.5523,0-1,.4477-1,1Zm2,1h6v6h-6v-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Platforms.propTypes = iconPropTypes;
}
const Play = /*#__PURE__*/React.forwardRef(function Play({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
      d: "M3.5,14C3.2,14,3,13.8,3,13.5v-11c0-0.2,0.1-0.3,0.2-0.4C3.4,2,3.6,2,3.8,2.1l9.5,5.5c0.2,0.1,0.3,0.4,0.2,0.7 c0,0.1-0.1,0.1-0.2,0.2l-9.5,5.5C3.7,14,3.6,14,3.5,14z M4,3.4v9.3L12,8L4,3.4z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28ZM8,6.6909V25.3088L24.9248,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Play.propTypes = iconPropTypes;
}
const PlayFilled = /*#__PURE__*/React.forwardRef(function PlayFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.7,8.4l-5.5,3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.3-0.2-0.4V5 c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3C12,7.7,12.1,8,11.9,8.2C11.9,8.3,11.8,8.4,11.7,8.4L11.7,8.4z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PlayFilled.propTypes = iconPropTypes;
}
const PlayFilledAlt = /*#__PURE__*/React.forwardRef(function PlayFilledAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PlayFilledAlt.propTypes = iconPropTypes;
}
const PlayOutline = /*#__PURE__*/React.forwardRef(function PlayOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
      d: "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
    })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
      d: "M6,11.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.2-0.3-0.2-0.4V5c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3 C12,7.7,12.1,8,11.9,8.2c0,0.1-0.1,0.2-0.2,0.2l-5.5,3C6.2,11.5,6.1,11.5,6,11.5z M6.5,5.8v4.3l4-2.2L6.5,5.8z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PlayOutline.propTypes = iconPropTypes;
}
const PlayOutlineFilled = /*#__PURE__*/React.forwardRef(function PlayOutlineFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.7,8.4l-5.5,3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.3-0.2-0.4V5 c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3C12,7.7,12.1,8,11.9,8.2C11.9,8.3,11.8,8.4,11.7,8.4L11.7,8.4z"
    })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
      d: "M6.5 10.2L10.5 8 6.5 5.8z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.382L20.764 16 12 11.618 12 20.382z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PlayOutlineFilled.propTypes = iconPropTypes;
}
const Playlist = /*#__PURE__*/React.forwardRef(function Playlist({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H22V8H4z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H22V14H4z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18H16V20H4z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18L28 23 21 28 21 18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Playlist.propTypes = iconPropTypes;
}
const Plug = /*#__PURE__*/React.forwardRef(function Plug({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Zm0,8a6,6,0,0,1-12,0V10H22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Plug.propTypes = iconPropTypes;
}
const PlugFilled = /*#__PURE__*/React.forwardRef(function PlugFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PlugFilled.propTypes = iconPropTypes;
}
const Png = /*#__PURE__*/React.forwardRef(function Png({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23H24a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H24V21h4V17H26V15h4Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19L14.32 9 12 9 12 23 14 23 14 13 17.68 23 20 23 20 9 18 9 18 19z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M4,23H2V9H8a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H4Zm0-7H8V11H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Png.propTypes = iconPropTypes;
}
const PointOfPresence = /*#__PURE__*/React.forwardRef(function PointOfPresence({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H18a2.0021,2.0021,0,0,1-2-2V18a2.0021,2.0021,0,0,1,2-2h2v2H18V28H28V18H26V16h2a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M14,16H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H14a2.0021,2.0021,0,0,1,2,2V6H14V4H4V14H14V12h2v2A2.0021,2.0021,0,0,1,14,16Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M26,9a2.9926,2.9926,0,0,0-5.8157-1H9v2H20.1843A2.9939,2.9939,0,0,0,22,11.8154V23h2V11.8159A2.9958,2.9958,0,0,0,26,9Zm-3,1a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,23,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PointOfPresence.propTypes = iconPropTypes;
}
const WatsonHealthPointerText = /*#__PURE__*/React.forwardRef(function WatsonHealthPointerText({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M13.71 12.29L7.41 6 13 6 13 4 4 4 4 13 6 13 6 7.41 12.29 13.71 13.71 12.29z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H12a2,2,0,0,1-2-2V18h2V28H28V12H18V10H28a2,2,0,0,1,2,2V28A2,2,0,0,1,28,30Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M22,15H17v2h5v2H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V17A2,2,0,0,0,22,15Zm0,8H18V21h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthPointerText.propTypes = iconPropTypes;
}
const Police = /*#__PURE__*/React.forwardRef(function Police({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24H12V30H10z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M21,20H7a3.0033,3.0033,0,0,1-3-3V6H2V17a5.0059,5.0059,0,0,0,5,5H21a4.9419,4.9419,0,0,1,2.105.481L17,28.5859,18.4141,30l6.3071-6.3071A4.96,4.96,0,0,1,26,27v3h2V27A7.0078,7.0078,0,0,0,21,20Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2746,4.0386l-7-2a1.0013,1.0013,0,0,0-.55,0l-7,2A.9993.9993,0,0,0,10.03,5.2422L11,9.123V11A7,7,0,1,0,25,11V9.123l.97-3.8808A.9993.9993,0,0,0,25.2746,4.0386ZM18,4.04l5.7952,1.6558L23.219,8H19V6H17V8H12.781l-.5762-2.3042ZM18,16a5.0058,5.0058,0,0,1-5-5V10H23v1A5.0058,5.0058,0,0,1,18,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Police.propTypes = iconPropTypes;
}
const Policy = /*#__PURE__*/React.forwardRef(function Policy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M30,18A6,6,0,1,0,20,22.46v7.54l4-1.8926,4,1.8926V22.46A5.98,5.98,0,0,0,30,18Zm-4,8.84-2-.9467L22,26.84V23.65a5.8877,5.8877,0,0,0,4,0ZM24,22a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,22Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H16V16H9z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H19V10H9z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M6,30a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V8H22V4H6V28H16v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Policy.propTypes = iconPropTypes;
}
const Popup = /*#__PURE__*/React.forwardRef(function Popup({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H10A2.0059,2.0059,0,0,0,8,6V20a2.0059,2.0059,0,0,0,2,2H28a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,28,4Zm0,16H10V6H28Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26H4V16H6V14H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H18a2.0059,2.0059,0,0,0,2-2V24H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Popup.propTypes = iconPropTypes;
}
const PortDefinition = /*#__PURE__*/React.forwardRef(function PortDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m19,7v-3.3999c0-.8837-.7164-1.6001-1.6001-1.6001H4v2h13v3h-6c-1.1046,0-2,.8954-2,2v14c0,1.1046.8954,2,2,2h6v3H4v2h13.3999c.8837,0,1.6001-.7164,1.6001-1.6001v-3.3999h6c1.1046,0,2-.8954,2-2v-14c0-1.1046-.8954-2-2-2h-6Zm6,16h-14v-14h14v14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PortDefinition.propTypes = iconPropTypes;
}
const PortInput = /*#__PURE__*/React.forwardRef(function PortInput({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28c-3.5928,0-6.9666-1.5903-9.2566-4.3632l1.542-1.2737c1.9087,2.3113,4.7207,3.6368,7.7146,3.6368,5.5139,0,10-4.486,10-10s-4.4861-10-10-10c-2.9939,0-5.8059,1.3256-7.7146,3.6368l-1.542-1.2737c2.29-2.7728,5.6638-4.3632,9.2566-4.3632,6.6169,0,12,5.3832,12,12s-5.3831,12-12,12Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M23 16L16 9 14.5859 10.4141 19.1719 15 2 15 2 17 19.1719 17 14.5859 21.5859 16 23 23 16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PortInput.propTypes = iconPropTypes;
}
const PortOutput = /*#__PURE__*/React.forwardRef(function PortOutput({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16L23 9 21.5859 10.4141 26.1719 15 9 15 9 17 26.1719 17 21.5859 21.5859 23 23 30 16z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28c-6.6167,0-12-5.3832-12-12S7.3833,4,14,4c2.335,0,4.5986,.6714,6.5461,1.9414l-1.0923,1.6753c-1.6221-1.0576-3.5078-1.6167-5.4539-1.6167-5.5139,0-10,4.486-10,10s4.4861,10,10,10c1.946,0,3.8318-.5591,5.4539-1.6167l1.0923,1.6753c-1.9475,1.27-4.2112,1.9414-6.5461,1.9414Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PortOutput.propTypes = iconPropTypes;
}
const PortUsage = /*#__PURE__*/React.forwardRef(function PortUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,7h-2v-3.3999c0-.8999-.7002-1.6001-1.6001-1.6001H4v2h13v3h-2c-3.3,0-6,2.7002-6,6v6c0,3.2998,2.7,6,6,6h2v3H4v2h13.3999c.8999,0,1.6001-.7002,1.6001-1.6001v-3.3999h2c3.3,0,6-2.7002,6-6v-6c0-3.2998-2.7-6-6-6Zm4,12c0,2.2002-1.8,4-4,4h-6c-2.2,0-4-1.7998-4-4v-6c0-2.2002,1.8-4,4-4h6c2.2,0,4,1.7998,4,4v6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PortUsage.propTypes = iconPropTypes;
}
const Portfolio = /*#__PURE__*/React.forwardRef(function Portfolio({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Portfolio.propTypes = iconPropTypes;
}
const Power = /*#__PURE__*/React.forwardRef(function Power({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
      d: "M11.2,2.9l-0.5,0.9c2.6,1.5,3.5,4.9,2,7.5s-4.9,3.5-7.5,2s-3.5-4.9-2-7.5c0.5-0.8,1.2-1.5,2-2L4.8,2.9 c-3.1,1.8-4.2,5.8-2.4,8.9s5.8,4.2,8.9,2.4s4.2-5.8,2.4-8.9C13.1,4.3,12.2,3.4,11.2,2.9z"
    })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5 1H8.5V8H7.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V16H15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Power.propTypes = iconPropTypes;
}
const PowerEnterprisePoolsMeteredCapacityIntegration = /*#__PURE__*/React.forwardRef(function PowerEnterprisePoolsMeteredCapacityIntegration({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0166,29.9937c-7.7085,0-13.9863-6.2646-13.9995-13.9761-.0068-3.7358,1.4443-7.2534,4.0854-9.9043l1.417,1.4121c-2.2642,2.272-3.5083,5.2866-3.5024,8.4888.0054,3.2056,1.2588,6.2168,3.5293,8.4795,2.2651,2.2573,5.2725,3.5,8.4702,3.5h.021c1.3477-.0024,2.6533-.2212,3.8799-.6514l.6611,1.8877c-1.4385.5039-2.9653.7612-4.5381.7637h-.0239Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M15,16h2v4h2c1.1046,0,2,.8954,2,2v3h-2v-3h-2v3h-2v-3h-2v3h-2v-3c0-1.1046.8954-2,2-2h2v-4Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M23,26h0c.5523,0,1,.4477,1,1h0c0,.5523-.4477,1-1,1h0c-.5523,0-1-.4477-1-1h0c0-.5523.4477-1,1-1Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M9,4h0c.5523,0,1,.4477,1,1h0c0,.5523-.4477,1-1,1h0c-.5523,0-1-.4477-1-1h0c0-.5523.4477-1,1-1Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9199,10.1064c-.4219-2.332-2.4678-4.1064-4.9199-4.1064s-4.498,1.7744-4.9199,4.1064c-1.7637.417-3.0801,2.0049-3.0801,3.8936,0,2.2061,1.7939,4,4,4h1v-2h-1c-1.1025,0-2-.8975-2-2s.8975-2,2-2h1v-1c0-1.6543,1.3457-3,3-3s3,1.3457,3,3v1h1c1.1025,0,2,.8975,2,2s-.8975,2-2,2h-1v2h1c2.2061,0,4-1.7939,4-4,0-1.8887-1.3164-3.4766-3.0801-3.8936Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8999,25.8885l-1.4141-1.4141c2.2681-2.2681,3.5171-5.2808,3.5171-8.4829,0-6.6167-5.3833-12-12-12-1.3491,0-2.6548.2168-3.8809.644l-.6582-1.8887c1.4385-.501,2.9653-.7554,4.5391-.7554,7.7197,0,14,6.2803,14,14,0,3.7363-1.457,7.251-4.103,9.897Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PowerEnterprisePoolsMeteredCapacityIntegration.propTypes = iconPropTypes;
}
const PowerVirtualServerDisasterRecoveryAutomation = /*#__PURE__*/React.forwardRef(function PowerVirtualServerDisasterRecoveryAutomation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M9,16h0c0,.3369.024.6749.0714,1.006l-1.9795.2832c-.061-.4238-.0919-.858-.0919-1.2892,0-4.9629,4.0376-9,9-9,2.0435,0,4.0444.7041,5.6348,1.9814l-1.2529,1.5596c-1.2544-1.0083-2.7696-1.541-4.3819-1.541-3.8599,0-6.9999,3.1401-6.9999,7.0001h-.0001ZM8,20c0,.5522.4478,1,1,1s1-.4478,1-1-.4478-1-1-1-1,.4478-1,1ZM16,4c6.6166,0,12,5.3833,12,12h2c0-7.7197-6.2803-14-14-14-1.6431,0-3.2529.2822-4.7846.8389l.6836,1.8799c1.3115-.4771,2.6913-.7188,4.101-.7188ZM22,12c0,.5522.4478,1,1,1s1-.4478,1-1-.4478-1-1-1-1,.4478-1,1ZM9,6c.5522,0,1-.4478,1-1s-.4478-1-1-1-1,.4478-1,1,.4478,1,1,1ZM4,16h0c0-3.2051,1.2481-6.2188,3.5147-8.4854l-1.4141-1.4141c-2.6445,2.6445-4.1006,6.1603-4.1006,9.8995,0,7.7197,6.2803,14,14,14v-2c-6.6166,0-12-5.3832-12-12ZM28.5,25.5c0,1.6543-1.3457,3-3,3s-3-1.3457-3-3c0-.4617.1135-.8942.3006-1.2853l-5.5153-5.5153c-.3911.1871-.8236.3006-1.2853.3006-1.6543,0-3-1.3457-3-3s1.3457-3,3-3,3,1.3457,3,3c0,.4617-.1135.8942-.3006,1.2853l5.5153,5.5153c.3911-.1871.8236-.3006,1.2853-.3006,1.6543,0,3,1.3456,3,2.9999h0ZM16,17c.5513,0,1-.4487,1-1s-.4487-1-1-1-1,.4487-1,1,.4487,1,1,1ZM26.5,25.5c0-.5518-.4482-1-1-1s-1,.4482-1,1,.4482,1,1,1,1-.4482,1-1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PowerVirtualServerDisasterRecoveryAutomation.propTypes = iconPropTypes;
}
const Ppt = /*#__PURE__*/React.forwardRef(function Ppt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V10.9985H14Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M4,23H2V9H8a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H4Zm0-7H8V10.9985H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Ppt.propTypes = iconPropTypes;
}
const PresentationFile = /*#__PURE__*/React.forwardRef(function PresentationFile({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H17V18H15z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14H22V18H20z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H12V18H10z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PresentationFile.propTypes = iconPropTypes;
}
const Pressure = /*#__PURE__*/React.forwardRef(function Pressure({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pressure.propTypes = iconPropTypes;
}
const PressureFilled = /*#__PURE__*/React.forwardRef(function PressureFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H10V25H6l10-9,10,9H22Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M16,16,6,7h4V2H22V7h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PressureFilled.propTypes = iconPropTypes;
}
const PreviousFilled = /*#__PURE__*/React.forwardRef(function PreviousFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PreviousFilled.propTypes = iconPropTypes;
}
const PreviousOutline = /*#__PURE__*/React.forwardRef(function PreviousOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PreviousOutline.propTypes = iconPropTypes;
}
const PricingConsumption = /*#__PURE__*/React.forwardRef(function PricingConsumption({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,2v2c6.63,0,12,5.37,12,12s-5.37,12-12,12v2c7.73,0,14-6.27,14-14S23.73,2,16,2Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m8.24,25.14l-1.29,1.53c1.23,1.04,2.64,1.87,4.18,2.44l.68-1.88c-1.32-.49-2.53-1.2-3.58-2.09h.01Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m4.19,18l-1.97.41c.28,1.63.84,3.16,1.64,4.54l1.73-.95c-.68-1.18-1.16-2.61-1.4-4Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m5.59,10l-1.73-1c-.79,1.38-1.35,2.96-1.64,4.59l1.97.35c.24-1.39.72-2.75,1.4-3.93v-.01Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m11.82,4.76l-.68-1.88c-1.54.57-2.95,1.4-4.18,2.44l1.29,1.53c1.05-.89,2.26-1.6,3.58-2.09h-.01Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,12v-2h-4v-3h-2v3h-2c-1.103,0-2,.897-2,2v3c0,1.103.897,2,2,2h6v3h-8v2h4v3h2v-3h2c1.103,0,2-.8975,2-2v-3c0-1.103-.897-2-2-2h-6v-3h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PricingConsumption.propTypes = iconPropTypes;
}
const PricingContainer = /*#__PURE__*/React.forwardRef(function PricingContainer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,2h-5v2h5v24h-5v2h5c1.1,0,2-.9,2-2V4c0-1.1-.9-2-2-2Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m23,20.52c0-4.62-3.78-5.14-6.82-5.56-3.31-.46-5.18-.86-5.18-3.71,0-2.39,2.51-3.24,4.65-3.24,2.32,0,4.14.86,5.57,2.63l1.56-1.26c-1.52-1.88-3.46-2.97-5.78-3.28v-3.1h-2v3.02c-3.62.22-6,2.26-6,5.22,0,4.73,3.83,5.26,6.91,5.69,3.25.45,5.09.84,5.09,3.58,0,3.03-3.13,3.48-5,3.48-3.43,0-4.88-.96-6.22-2.63l-1.56,1.26c1.77,2.19,3.73,3.17,6.78,3.34v3.04h2v-3.04c3.73-.3,6-2.33,6-5.44Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m4,4h5V2H4c-1.1,0-2,.9-2,2v24c0,1.1.9,2,2,2h5v-2H4V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PricingContainer.propTypes = iconPropTypes;
}
const PricingQuickProposal = /*#__PURE__*/React.forwardRef(function PricingQuickProposal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29,20.52c0-4.62-3.78-5.14-6.82-5.56-3.31-.46-5.18-.86-5.18-3.71,0-2.39,2.51-3.24,4.65-3.24,2.32,0,4.14.86,5.57,2.63l1.56-1.26c-1.52-1.88-3.46-2.97-5.78-3.28v-3.1h-2v3.02c-3.62.22-6,2.26-6,5.22,0,4.73,3.83,5.26,6.91,5.69,3.25.45,5.09.84,5.09,3.58,0,3.03-3.13,3.48-5,3.48-3.43,0-4.88-.96-6.22-2.63l-1.56,1.26c1.77,2.19,3.73,3.17,6.78,3.34v3.04h2v-3.04c3.73-.3,6-2.33,6-5.44Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M3 11H11V13H3z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M3 19H11V21H3z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M5 15H13V17H5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PricingQuickProposal.propTypes = iconPropTypes;
}
const PricingTailored = /*#__PURE__*/React.forwardRef(function PricingTailored({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,21h-2c0-2.8226,0-7.0881-10.0903-8.0042l.1807-1.9917c11.9097,1.0811,11.9097,6.8802,11.9097,9.9958Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16.9097,20.9958c-11.9097-1.0811-11.9097-6.8802-11.9097-9.9958h2c0,2.8226,0,7.0881,10.0903,8.0042l-.1807,1.9917Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m23,20.52c0-4.62-3.78-5.14-6.82-5.56-3.31-.46-5.18-.86-5.18-3.71,0-2.39,2.51-3.24,4.65-3.24,2.32,0,4.14.86,5.57,2.63l1.56-1.26c-1.52-1.88-3.46-2.97-5.78-3.28v-3.1h-2v3.02c-3.62.22-6,2.26-6,5.22,0,4.73,3.83,5.26,6.91,5.69,3.25.45,5.09.84,5.09,3.58,0,3.03-3.13,3.48-5,3.48-3.43,0-4.88-.96-6.22-2.63l-1.56,1.26c1.77,2.19,3.73,3.17,6.78,3.34v3.04h2v-3.04c3.73-.3,6-2.33,6-5.44Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PricingTailored.propTypes = iconPropTypes;
}
const PricingTraditional = /*#__PURE__*/React.forwardRef(function PricingTraditional({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17,15.0698v-6.9536c1.6909.2793,3.084,1.1021,4.2219,2.5117l1.5562-1.2559c-1.5195-1.8823-3.4619-2.9736-5.7781-3.2759v-3.0962h-2v3.022c-3.6152.2192-6,2.2603-6,5.2202,0,4.2739,3.1265,5.1191,6,5.5586v7.1616c-2.7192-.1777-4.0186-1.1001-5.2219-2.5903l-1.5562,1.2559c1.7703,2.1934,3.7332,3.168,6.7781,3.3369v3.0352h2v-3.0449c3.7256-.3042,6-2.3271,6-5.4399,0-4.209-3.1428-5.0156-6-5.4453Zm-6-3.8276c0-2.1533,2.0293-3.0537,4-3.2134v6.7466c-2.5696-.4238-4-1.043-4-3.5332Zm6,12.71v-6.8574c2.5669.4155,4,1.0044,4,3.4204,0,2.5361-2.1902,3.2656-4,3.437Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PricingTraditional.propTypes = iconPropTypes;
}
const Printer = /*#__PURE__*/React.forwardRef(function Printer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Printer.propTypes = iconPropTypes;
}
const Process = /*#__PURE__*/React.forwardRef(function Process({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "m12,25c-.7383,0-1.3762.4048-1.7227,1h-5.6301l2.6479-5.0923c.2273.0552.4609.0923.7048.0923,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3-3,1.3457-3,3c0,.6787.2349,1.2979.6162,1.8013l-3.5034,6.7373c-.1611.3101-.1489.6816.0325.9805.1812.2983.5054.481.8547.481h7.2773c.3464.5952.9844,1,1.7227,1,1.1045,0,2-.8955,2-2s-.8955-2-2-2Zm-4-8c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "m29.8872,26.5386l-4.041-7.771c.0986-.2363.1538-.4956.1538-.7676,0-1.1045-.8955-2-2-2s-2,.8955-2,2,.8955,2,2,2c.0757,0,.1477-.0142.2212-.0225l3.1316,6.0225h-4.5371c-.4141-1.1611-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.302,0,2.4016-.8389,2.8157-2h6.1843c.3494,0,.6736-.1826.8547-.481.1814-.2988.1936-.6704.0325-.9805Zm-9.8872,1.4614c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "m21,8c-.2439,0-.4778.0371-.7048.0923l-3.408-6.5537c-.1721-.3311-.5298-.5386-.8872-.5386s-.7151.2075-.8872.5386l-3.8914,7.4839c-.0737-.0083-.1458-.0225-.2214-.0225-1.1045,0-2,.8955-2,2s.8955,2,2,2,2-.8955,2-2c0-.272-.0552-.5312-.1538-.7676l3.1538-6.0649,2.6162,5.0312c-.3813.5034-.6162,1.1226-.6162,1.8013,0,1.6543,1.3457,3,3,3s3-1.3457,3-3-1.3457-3-3-3Zm0,4c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Process.propTypes = iconPropTypes;
}
const ProcessAutomate = /*#__PURE__*/React.forwardRef(function ProcessAutomate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "m31,17c0-1.6543-1.3457-3-3-3s-3,1.3457-3,3c0,1.3018.8384,2.4014,2,2.8154v2.6104l-11,6.4165-10.0154-5.8423,22.5193-13.1362c.3071-.1792.4961-.5083.4961-.8638s-.189-.6846-.4961-.8638L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362s-.3481.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5083-.4961.8638v3.1846c-1.1616.4141-2,1.5137-2,2.8154,0,1.6543,1.3457,3,3,3s3-1.3457,3-3c0-1.3018-.8384-2.4014-2-2.8159v-2.6099l11-6.4165,10.0154,5.8423L3.4961,22.1362c-.3071.1792-.4961.5083-.4961.8638s.189.6846.4961.8638l12,7c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l12-7c.3071-.1792.4961-.5083.4961-.8638v-3.1841c1.1616-.4146,2-1.5142,2-2.8159Zm-27-1c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Zm24,2c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ProcessAutomate.propTypes = iconPropTypes;
}
const Product = /*#__PURE__*/React.forwardRef(function Product({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H14V20H8z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H18V24H8z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Product.propTypes = iconPropTypes;
}
const ProgressBar = /*#__PURE__*/React.forwardRef(function ProgressBar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21H4a2.0021,2.0021,0,0,1-2-2V13a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,21ZM4,13v6H28V13Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H20V17H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ProgressBar.propTypes = iconPropTypes;
}
const ProgressBarRound = /*#__PURE__*/React.forwardRef(function ProgressBarRound({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26a10.0162,10.0162,0,0,1-7.4531-3.3325l1.49-1.334A8,8,0,1,0,16,8V6a10,10,0,0,1,0,20Z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ProgressBarRound.propTypes = iconPropTypes;
}
const Promote = /*#__PURE__*/React.forwardRef(function Promote({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21L17.4 22.4 14.8 25 23 25 23 27 14.8 27 17.4 29.6 16 31 11 26z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 19H17.6V21H6.3z",
    transform: "rotate(-45.001 12 20)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22h-2v-5c0-0.3,0.1-0.5,0.3-0.7l4.1-4.1c1.7-1.7,2.6-4,2.6-6.4V4h-1.9c-2.4,0-4.7,0.9-6.4,2.6l-4.1,4.1 C15.5,10.9,15.3,11,15,11H7.5l-2.6,3.3l5.3,0.8l-0.3,2l-7-1c-0.4-0.1-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l4-5C6.4,9.1,6.7,9,7,9h7.6 l3.8-3.8C20.4,3.1,23.2,2,26.1,2H28c1.1,0,2,0.9,2,2v1.9c0,2.9-1.1,5.7-3.2,7.8L23,17.4V22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Promote.propTypes = iconPropTypes;
}
const PromptSession = /*#__PURE__*/React.forwardRef(function PromptSession({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.5859L25 23.5859 25 21 23 21 23 24.4141 25.5859 27 27 25.5859z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "m24,31c-3.8599,0-7-3.1401-7-7s3.1401-7,7-7,7,3.1401,7,7-3.1401,7-7,7Zm0-12c-2.7571,0-5,2.2429-5,5s2.2429,5,5,5,5-2.2429,5-5-2.2429-5-5-5Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "m28,15h2V5c0-1.103-.8975-2-2-2h-3v2h3v10Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "13",
    r: "2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "2"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "13",
    r: "2"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "m7,23h-3c-1.103,0-2-.8975-2-2V5c0-1.103.897-2,2-2h3v2h-3v16h3v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PromptSession.propTypes = iconPropTypes;
}
const PromptTemplate = /*#__PURE__*/React.forwardRef(function PromptTemplate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "m31.5,23c-.8271,0-1.5-.6729-1.5-1.5v-1.5c0-1.1025-.8972-2-2-2h-2v2h2v1.5c0,.98.4072,1.8643,1.0581,2.5-.6509.6357-1.0581,1.52-1.0581,2.5v1.5h-2v2h2c1.1028,0,2-.8975,2-2v-1.5c0-.8271.6729-1.5,1.5-1.5h.5v-2h-.5Z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "m16,20v1.5c0,.8271-.6729,1.5-1.5,1.5h-.5v2h.5c.8271,0,1.5.6729,1.5,1.5v1.5c0,1.1025.8972,2,2,2h2v-2h-2v-1.5c0-.98-.4072-1.8643-1.0581-2.5.6509-.6357,1.0581-1.52,1.0581-2.5v-1.5h2v-2h-2c-1.1028,0-2,.8975-2,2Z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "m28,15h2V5c0-1.103-.8975-2-2-2h-3v2h3v10Z"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "13",
    r: "2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "13",
    r: "2"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "m7,23h-3c-1.103,0-2-.8975-2-2V5c0-1.103.897-2,2-2h3v2h-3v16h3v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PromptTemplate.propTypes = iconPropTypes;
}
const PropertyRelationship = /*#__PURE__*/React.forwardRef(function PropertyRelationship({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16L22 24 20.6 22.6 27.2 16 20.6 9.4 22 8z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15H20V17H12z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16L10 8 11.4 9.4 4.8 16 11.4 22.6 10 24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PropertyRelationship.propTypes = iconPropTypes;
}
const PullRequest = /*#__PURE__*/React.forwardRef(function PullRequest({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m25,22.1421v-13.1421c0-2.2056-1.7944-4-4-4h-4.1719l2.5859-2.5859-1.4141-1.4141-5,5,5,5,1.4141-1.4141-2.5859-2.5859h4.1719c1.1028,0,2,.8975,2,2v13.1421c-1.7202.4473-3,1.9995-3,3.8579,0,2.2056,1.7944,4,4,4s4-1.7944,4-4c0-1.8584-1.2798-3.4106-3-3.8579Zm-1,5.8579c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m4,6c0,1.8584,1.2798,3.4106,3,3.8579v12.2842c-1.7202.447-3,1.9993-3,3.8579,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8586-1.2798-3.4109-3-3.8579v-12.2842c1.7202-.4473,3-1.9995,3-3.8579,0-2.2056-1.7944-4-4-4s-4,1.7944-4,4Zm6,20c0,1.1025-.897,2-2,2s-2-.8975-2-2c0-1.1025.897-2,2-2s2,.8975,2,2Zm0-20c0,1.103-.897,2-2,2s-2-.897-2-2c0-1.103.897-2,2-2s2,.897,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PullRequest.propTypes = iconPropTypes;
}
const PunctuationCheck = /*#__PURE__*/React.forwardRef(function PunctuationCheck({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M23,27.1781l-2.59-2.59-1.41,1.4119,4,4,7-7-1.41-1.4119-5.59,5.59ZM14,16h-3v-.1689c0-1.397.7441-2.7114,1.9419-3.4302l1.1416-.6865-1.03-1.7144-1.1404.686c-1.7969,1.0781-2.9131,3.0493-2.9131,5.145v5.1689c0,.5522.4478,1,1,1h4c.5522,0,1-.4478,1-1v-4c0-.5522-.4478-1-1-1h0ZM22,16h-3v-.1689c0-1.397.7441-2.7114,1.9419-3.4302l1.1416-.6865-1.03-1.7144-1.1404.686c-1.7969,1.0781-2.9131,3.0493-2.9131,5.145v5.1689c0,.5522.4478,1,1,1h4c.5522,0,1-.4478,1-1v-4c0-.5522-.4478-1-1-1h0ZM12,28h-6c-1.103,0-2-.8975-2-2V6c0-1.103.897-2,2-2h20c1.1025,0,2,.897,2,2v11h-2V6H6v20h6v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PunctuationCheck.propTypes = iconPropTypes;
}

export { ParentNode, PartDefinition, PartUsage, PartitionAuto, PartitionCollection, PartitionRepartition, PartitionSame, PartitionSpecific, PartlyCloudy, PartlyCloudyNight, Partnership, PassengerDrinks, PassengerPlus, Password, Paste, Pause, PauseFilled, PauseFuture, PauseOutline, PauseOutlineFilled, PausePast, PcnENode, PcnMilitary, PcnPNode, PcnZNode, Pdf, PdfReference, Pedestrian, PedestrianChild, PedestrianFamily, Pen, PenFountain, Pending, PendingFilled, PentagonDownOutline, PentagonDownSolid, PentagonLeftOutline, PentagonLeftSolid, PentagonOutline, PentagonRightOutline, PentagonRightSolid, PentagonSolid, Percentage, PercentageFilled, PerformAction, Person, PersonFavorite, Pest, Phone, PhoneApplication, PhoneBlock, PhoneBlockFilled, PhoneFilled, PhoneIncoming, PhoneIncomingFilled, PhoneIp, PhoneOff, PhoneOffFilled, PhoneOutgoing, PhoneOutgoingFilled, PhoneSettings, PhoneVoice, PhoneVoiceFilled, PhraseSentiment, PicnicArea, PiggyBank, PiggyBankSlot, Pills, PillsAdd, PillsSubtract, Pin, PinFilled, Pipelines, Plan, Plane, PlanePrivate, PlaneSea, Platforms, Play, PlayFilled, PlayFilledAlt, PlayOutline, PlayOutlineFilled, Playlist, Plug, PlugFilled, Png, PointOfPresence, Police, Policy, Popup, PortDefinition, PortInput, PortOutput, PortUsage, Portfolio, Power, PowerEnterprisePoolsMeteredCapacityIntegration, PowerVirtualServerDisasterRecoveryAutomation, Ppt, PresentationFile, Pressure, PressureFilled, PreviousFilled, PreviousOutline, PricingConsumption, PricingContainer, PricingQuickProposal, PricingTailored, PricingTraditional, Printer, Process, ProcessAutomate, Product, ProgressBar, ProgressBarRound, Promote, PromptSession, PromptTemplate, PropertyRelationship, PullRequest, PunctuationCheck, WatsonHealthPetImageB, WatsonHealthPetImageO, WatsonHealthPointerText };
